import { render } from "./Logout.vue?vue&type=template&id=1b08b8e1"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=1b08b8e1&lang=css"

import exportComponent from "/home/darnell/Development/accounting/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__